module.exports = __webpack_public_path__ + "static/media/x-rays0.8e0e9d5a.png";